import ChartEvent from '../chart-events/chart-event'
import { CanvasSvgImg, ChartEventBadgeCommonType } from './CanvasSvgImg'
import ElementModel from './element'
import Pane from './pane'

class ChartEventElement extends ElementModel {
  static initClass(paneModel: typeof Pane) {
    this.configure('ChartEventElement', 'instance', 'lastChange', 'zIndex', 'yIndex', 'elementId', 'updateOhlcVersion')
    this.belongsTo('pane', paneModel)
  }

  declare instance: ChartEvent
  declare updateOhlcVersion?: number
  declare updateChartEventsVersion?: number
  yIndex = 0

  getChartEventBadgeImage(props: ChartEventBadgeCommonType) {
    return CanvasSvgImg.getChartEventIcon(props, () => {
      this.instance.trigger('change', this.instance)
    })
  }

  getChartEventData() {
    return this.instance.model
      .chart()
      .quote()
      ?.chartEvents?.find((stockEvent) => stockEvent.elementId === this?.elementId)
  }

  toObject() {
    return {
      ...super.toObject(),
      yIndex: this.yIndex,
    }
  }

  toConfig() {
    return {
      ...super.toConfig(),
      yIndex: this.yIndex,
    }
  }
}

export default ChartEventElement
